import { defineComponent as _defineComponent } from 'vue'
import Grid from '@/components/grids/LfGrid/LfGridComponent.vue'
import { computed, PropType } from 'vue'
import { ActionName, GridConfiguration } from '@/components/grids/LfGrid/LfGridTypes'
import { ToolbarItemModel } from '@syncfusion/ej2-vue-filemanager'
import { formatFieldsTypeDateEPOCH } from '@/helpers/dateTime'


export default /*#__PURE__*/_defineComponent({
  __name: 'LexonSimpleRowComponent',
  props: {
  label: {
    type: String,
    required: true
  },
  rowConfiguration: {
    type: Object as PropType<GridConfiguration>,
    required: true
  },
  rowData: {
    type: [Array, Object],
    required: true
  }
},
  setup(__props) {

const props = __props;



const itemData = computed(() => {
  if (!props.rowData.length) {
    return []
  }
  return formatFieldsTypeDateEPOCH(props.rowData)
})

const toolbarOptions = computed((): ToolbarItemModel[] => {
  return [
    {
      id: ActionName.TITLE,
      text: props.label,
      cssClass: 'lf-title',
      align: 'Left'
    }
  ]
})

return { __sfc: true,props, itemData, toolbarOptions, Grid }
}

})